import "./index.css";
// src/ProductToken/ProductToken.tsx
import Button from "@cloudscape-design/components/button";
import Link from "@cloudscape-design/components/link";
import { ListingBadge } from "@amzn/apo-ux-patterns/components/ListingBadge";

// src/ProductToken/ProductToken.module.scss
var ProductToken_module_default = {
  token: "ProductToken_module_token2",
  tokenClickable: "ProductToken_module_tokenClickable2",
  tokenIcon: "ProductToken_module_tokenIcon2",
  tokenContent: "ProductToken_module_tokenContent2",
  tokenLabel: "ProductToken_module_tokenLabel2",
  externalLinkIcon: "ProductToken_module_externalLinkIcon2",
  tokenDescription: "ProductToken_module_tokenDescription2",
  tokenBadges: "ProductToken_module_tokenBadges2",
  tokenDismiss: "ProductToken_module_tokenDismiss2"
};

// src/ProductToken/ProductToken.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ProductToken = ({ product, onDismiss, productUrl }) => {
  const tokenContent = /* @__PURE__ */ jsxs(Fragment, { children: [
    product.productLogoUrl && /* @__PURE__ */ jsx("img", { src: product.productLogoUrl, alt: "", className: ProductToken_module_default.tokenIcon }),
    /* @__PURE__ */ jsxs("div", { className: ProductToken_module_default.tokenContent, children: [
      /* @__PURE__ */ jsx("div", { className: ProductToken_module_default.tokenLabel, children: productUrl ? /* @__PURE__ */ jsx(Link, { external: true, href: productUrl, fontSize: "inherit", children: product.productName }) : product.productName }),
      /* @__PURE__ */ jsxs("div", { className: ProductToken_module_default.tokenDescription, children: [
        "by ",
        product.vendorName
      ] }),
      product.badges && product.badges.length > 0 && /* @__PURE__ */ jsx("div", { className: ProductToken_module_default.tokenBadges, children: product.badges.map((badge) => badge.value && /* @__PURE__ */ jsx(ListingBadge, { variant: badge.value }, badge.value)) })
    ] }),
    onDismiss && /* @__PURE__ */ jsx(Button, { variant: "icon", iconName: "close", ariaLabel: `Remove ${product.productName}`, onClick: onDismiss, className: ProductToken_module_default.tokenDismiss })
  ] });
  return /* @__PURE__ */ jsx("div", { className: ProductToken_module_default.token, children: tokenContent });
};
export {
  ProductToken
};
//# sourceMappingURL=index.js.map
